/**
 * Axios-konfiguration som binder ett anrop till en bestämd organisation.
 *
 * Request-interceptorn i `src/lib/axios.ts` sätter annars `X-Organisation-Id` från
 * den organisation användaren valt i menyn — och i hubbläget "Alla organisationer"
 * finns ingen sådan, så huvudet utelämnas helt. Ett anrop som bär organisationen i
 * sökvägen men saknar huvudet avvisas av `OrganisationRoleAuthorizationAspect` med
 * 400, eftersom path-fallbacken bara gäller endpoints som uttryckligen tillåter
 * den.
 *
 * Används därför av allt som läser en annan förening än den valda — hubben läser
 * allihop. Backend kräver att huvudet matchar organisationen i sökvägen, vilket
 * det gör här per konstruktion: samma id går till båda.
 */
export const medOrgHuvud = (orgId?: string | null) =>
  orgId ? { headers: { 'X-Organisation-Id': orgId } } : {};
